import { render } from "./Farms.vue?vue&type=template&id=3c94596c"
import script from "./Farms.vue?vue&type=script&lang=ts"
export * from "./Farms.vue?vue&type=script&lang=ts"
script.render = render

export default script